import api from './api';

// Admin › Infra › Sync Diverter — legacy OXI API keys the legacy stack forwards to the hub (sync_diverter on the legacy
// database, served by the ui-v2-legacyingress lambda).
const syncDiverterService = {
    list:      ()         => api.get('/admin/sync-diverter'),
    create:    (body)     => api.post('/admin/sync-diverter', body),          // { apiKey, note? }
    update:    (id, body) => api.put(`/admin/sync-diverter/${id}`, body),     // { active?, note? }
    remove:    (id)       => api.delete(`/admin/sync-diverter/${id}`),
    // The decrypted API key of one row — audited as a READ, so it is fetched only when asked for.
    revealKey: (id)       => api.get(`/admin/sync-diverter/${id}/api-key`),
};

export default syncDiverterService;
